"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("./SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

var _Modal = require("./Modal");

var _Modal2 = _interopRequireDefault(_Modal);

var _MyCollection_Icon = require("./MyCollection_Icon");

var _MyCollection_Icon2 = _interopRequireDefault(_MyCollection_Icon);

var _CodeMirror = require("./CodeMirror");

var _CodeMirror2 = _interopRequireDefault(_CodeMirror);

var _PreviewBox = require("./PreviewBox");

var _PreviewBox2 = _interopRequireDefault(_PreviewBox);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColorPickerComponent = require("./objects/ColorPickerComponent");

var _ColorPickerComponent2 = _interopRequireDefault(_ColorPickerComponent);

var _jsFileDownload = require("js-file-download");

var _jsFileDownload2 = _interopRequireDefault(_jsFileDownload);

var _helpers = require("../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ls = require("localstorage-ttl");

var MyCollection = function (_React$Component) {
	_inherits(MyCollection, _React$Component);

	function MyCollection() {
		_classCallCheck(this, MyCollection);

		var _this = _possibleConstructorReturn(this, (MyCollection.__proto__ || Object.getPrototypeOf(MyCollection)).call(this));

		_this.getitemCode = function (internal_id) {
			if (!internal_id) {
				return;
			}

			_this.setState({
				status: "code"
			});

			var that = _this;
			_this.props.api(iconPressConfig.rest_url + "download_icon", "post", { internal_id: internal_id }).then(function (response) {
				if (response.success) {
					that.setState({ itemCode: response.data });
				} else {
					that.props.handleModal("error", iconPressConfig.translations.ERROR + ": " + response.data);
				}
				that.setState({
					status: ""
				});
			});
		};

		_this.updateCode = function (newCode) {
			_this.setState({
				itemCode: newCode
			});
		};

		_this.saveIconCode = function (event, overwrite) {
			event.preventDefault();

			if (!_this.state.modalItem.internal_id) {
				return;
			}

			var that = _this;
			var data = {
				code: _this.state.itemCode,
				internal_id: _this.state.modalItem.internal_id,
				overwrite: overwrite || false
			};

			_this.props.api(iconPressConfig.rest_url + "save_icon_code", "post", data).then(function (response) {
				if (response.success) {
					// close modal
					_this.closeModal();
					// remove cache
					localStorage.removeItem(iconPressConfig.plugin_slug + "_myCollection");
					// fetch icons again
					_this.getIcons();
					// reset svg contents
					_this.props.resetSvgContents();
				} else {
					that.props.handleModal("error", iconPressConfig.translations.ERROR + ": " + response.data);
				}
			});
		};

		_this.escCloseModal = function (event) {
			// listen to escape when modal is opened
			if (event.keyCode === 27 && Object.keys(_this.state.modalItem).length !== 0) {
				_this.closeModal();
			}
		};

		_this.changeColor = function (type, value) {
			var modalOpts = _extends({}, _this.state.modalItemOptions);
			modalOpts[type] = value;
			_this.setState({
				modalItemOptions: modalOpts
			});
		};

		_this.hexToRgb = function (hex) {
			// Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
			var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;

			hex = hex.replace(shorthandRegex, function (m, r, g, b) {
				return r + r + g + g + b + b;
			});

			var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
			return result ? {
				r: parseInt(result[1], 16),
				g: parseInt(result[2], 16),
				b: parseInt(result[3], 16)
			} : null;
		};

		_this.handleDeleteAll = function (event) {
			event.preventDefault();

			var that = _this;

			_this.setState({
				status: "delete"
			});

			var iconsToDelete = _this.state.iconsToDelete.length !== 0 ? _this.state.iconsToDelete : _this.state.my_collection.map(function (item, index) {
				return item.internal_id;
			});

			_this.props.api(iconPressConfig.rest_url + "delete_icons", "post", { icons: iconsToDelete }).then(function (response) {
				if (response.success) {
					// remove cache
					localStorage.removeItem(iconPressConfig.plugin_slug + "_myCollection");
					// Show Modal
					that.props.handleModal("confirmation-save", response.data);
					// update selected
					iconsToDelete.forEach(function (element) {
						that.props.toggleSelected({ internal_id: element });
					});
					// fetch icons again
					that.getIcons();
					// reset svg contents
					that.props.resetSvgContents();
					// Trigger delete event
					window.parent.dispatchEvent(new CustomEvent("iconpress:delete"));
				} else {
					// remove cache
					localStorage.removeItem(iconPressConfig.plugin_slug + "_myCollection");

					that.props.handleModal("error", iconPressConfig.translations.ERROR + ": " + response.data);
				}

				_this.setState({
					status: ""
				});
			});
		};

		_this.handleDownload = function (event, internal_id) {
			event.preventDefault();

			if (!internal_id) {
				return;
			}

			_this.setState({
				status: "download"
			});

			var that = _this;

			_this.props.api(iconPressConfig.rest_url + "download_icon", "post", { internal_id: internal_id }).then(function (response) {
				if (response.success) {
					(0, _jsFileDownload2.default)(response.data, internal_id + ".svg");
				} else {
					that.props.handleModal("error", iconPressConfig.translations.ERROR + ": " + response.data);
				}
				_this.setState({
					status: ""
				});
			});
		};

		_this.copyToClipboard = function (node) {
			document.getElementById(node).select();
			document.execCommand("copy");
		};

		_this.getIcons = _this.getIcons.bind(_this);
		_this.getSystemIcons = _this.getSystemIcons.bind(_this);
		_this.openModal = _this.openModal.bind(_this);
		_this.handleDelete = _this.handleDelete.bind(_this);
		_this.insertIntoOption = _this.insertIntoOption.bind(_this);
		_this.insertValueAndClosePanel = _this.insertValueAndClosePanel.bind(_this);
		_this.getCode = _this.getCode.bind(_this);
		_this.changeVal = _this.changeVal.bind(_this);

		_this.defaultModalItemOptions = {
			title: "",
			color: iconPressConfig.modal_item_color,
			size: "80",
			unit: "px",
			enableLink: false,
			link: "",
			target: "_self",
			hover_color: iconPressConfig.modal_item_color
		};

		_this.state = {
			my_collection: [],
			system_collection: [],
			activeModalCode: "",
			modalItem: {},
			modalItemOptions: _this.defaultModalItemOptions,
			itemCode: "",
			componentIsLoading: true,
			status: "",
			notice: "",
			iconsToDelete: []
		};
		return _this;
	}

	_createClass(MyCollection, [{
		key: "getIcons",
		value: function getIcons() {
			var _this2 = this;

			this.setState({
				componentIsLoading: true
			});

			// check for LS cache
			var cachedCollection = ls.get(iconPressConfig.plugin_slug + "_myCollection");

			if (cachedCollection && Object.keys(cachedCollection).length !== 0) {
				// if we have cache, update collection state
				// with stored data from LS
				this.setState({
					my_collection: [].concat(_toConsumableArray(cachedCollection)),
					componentIsLoading: false
				});
				if (iconPressConfig.debug == 1) {
					console.log("Fetching from LS.");
				}
				return;
			}

			this.props.api(iconPressConfig.rest_url + "get_user_collections").then(function (response) {
				if (response) {
					_this2.setState({
						my_collection: response["default"] || [],
						componentIsLoading: false
					});
					ls.set(iconPressConfig.plugin_slug + "_myCollection", response["default"] || [], 3600 * 1000);
				} else {
					if (iconPressConfig.debug === "1") {
						console.log("Collection is empty!");
						console.log("Response: ", response);
					}
					_this2.setState({
						componentIsLoading: false
					});
					return;
				}
			});
			return true;
		}
	}, {
		key: "getSystemIcons",
		value: function getSystemIcons() {
			var systemIcons = [];

			var systemSvg = document.getElementById("iconpress_svg_sprite_system");

			if (systemSvg) {
				var symbols = systemSvg.querySelectorAll("symbol");

				if (symbols && symbols.length !== 0) {
					Object.values(symbols).map(function (key, i) {
						systemIcons[i] = {};
						systemIcons[i].internal_id = key.getAttribute("id");
						systemIcons[i].title = "";
						systemIcons[i].type = "system";
					});
				}
			}

			this.setState({
				system_collection: systemIcons
			});
		}
	}, {
		key: "openModal",
		value: function openModal(event, item, type) {
			event.preventDefault();

			this.setState({
				activeModalCode: type,
				modalItem: item
			});

			if (item.type && item.type !== "local") {
				this.setState({
					notice: iconPressConfig.translations.COLOR_NOTICE
				});
			}

			// Check for editor
			if (type === "editor") {
				this.getitemCode(item.internal_id);
			}
		}
	}, {
		key: "handleCloseModal",
		value: function handleCloseModal(event) {
			event.preventDefault();
			this.closeModal();
		}
	}, {
		key: "closeModal",
		value: function closeModal() {
			this.setState({
				activeModalCode: "",
				modalItem: {},
				modalItemOptions: this.defaultModalItemOptions,
				itemCode: "",
				notice: ""
			});
		}
	}, {
		key: "switchActiveCode",
		value: function switchActiveCode(event, type) {
			event.preventDefault();
			this.setState({
				activeModalCode: type
			});
		}
	}, {
		key: "changeVal",
		value: function changeVal(event, type) {
			var modalOpts = _extends({}, this.state.modalItemOptions);
			modalOpts[type] = event.target.value;
			this.setState({
				modalItemOptions: modalOpts
			});
		}
	}, {
		key: "toggleLink",
		value: function toggleLink(event) {
			var modalOpts = _extends({}, this.state.modalItemOptions);
			modalOpts.enableLink = !this.state.modalItemOptions.enableLink;
			this.setState({
				modalItemOptions: modalOpts
			});
		}
	}, {
		key: "handleDelete",
		value: function handleDelete(event, internal_id) {
			var _this3 = this;

			event.preventDefault();

			var that = this;

			this.setState({
				status: "delete"
			});

			this.props.api(iconPressConfig.rest_url + "delete_icon", "post", { internal_id: internal_id }).then(function (response) {
				if (response.success) {
					// remove cache
					localStorage.removeItem(iconPressConfig.plugin_slug + "_myCollection");
					// Show Modal
					that.props.handleModal("confirmation-save", response.data);
					// update selected
					_this3.props.toggleSelected({ internal_id: internal_id });
					// fetch icons again
					_this3.getIcons();
					// reset svg contents
					_this3.props.resetSvgContents();
					// Trigger delete event
					window.parent.dispatchEvent(new CustomEvent("iconpress:delete"));
				} else {
					that.props.handleModal("error", iconPressConfig.translations.ERROR + ": " + response.data);
				}

				_this3.setState({
					status: ""
				});
			});
		}
	}, {
		key: "getCode",
		value: function getCode() {
			var codeType = this.state.activeModalCode;

			// Custom Code Stuff
			var _state$modalItem = this.state.modalItem,
			    internal_id = _state$modalItem.internal_id,
			    title = _state$modalItem.title;
			var _state$modalItemOptio = this.state.modalItemOptions,
			    color = _state$modalItemOptio.color,
			    size = _state$modalItemOptio.size,
			    unit = _state$modalItemOptio.unit,
			    enableLink = _state$modalItemOptio.enableLink,
			    link = _state$modalItemOptio.link,
			    target = _state$modalItemOptio.target,
			    hover_color = _state$modalItemOptio.hover_color;
			// title

			var optionsTitle = this.state.modalItemOptions.title;
			var finalTitle = this.state.modalItemOptions.title !== "" ? this.state.modalItemOptions.title : title;
			// styles
			var colorStyle = color ? "color:" + color + ";" : "";
			var sizeStyle = size ? "font-size:" + size + unit + ";" : "";
			var style = colorStyle + " " + sizeStyle;

			var codeTemplate = "";

			// html link
			var svgColorLink = "";
			if (enableLink && link != "" && hover_color != "") {
				svgColorLink = "onmouseover=\"this.style.color='" + hover_color + "'\" onmouseout=\"this.style.color='" + color + "'\"";
			}

			// SHORTCODE
			if (codeType == "shortcode") {
				var link_code = "";
				if (enableLink && link != "") {
					link_code = "link=\"" + link + "\" target=\"" + target + "\" hover_color=\"" + hover_color + "\" color=\"" + color + "\"";
				}
				codeTemplate = "[iconpress id=\"" + internal_id + "\" title=\"" + finalTitle + "\" style=\"" + style + "\" " + link_code + "]";
			}

			// SVG CODE
			else if (codeType == "svg" || codeType == "svg_inline") {
					var spriteId = "iconpress_svg_sprite";

					if (this.state.modalItem.type_internal === "system") {
						spriteId = "iconpress_svg_sprite_system";
					}

					var svgSprite = document.getElementById(spriteId);
					if (svgSprite) {
						var svgSymbol = svgSprite.querySelectorAll("#" + internal_id);

						if (svgSymbol && svgSymbol.length !== 0) {
							// link start
							if (enableLink && link != "") {
								codeTemplate += "<a class=\"iconpress-iconLink\" href=\"" + link + "\" target=\"" + target + "\">";
							}

							// svg code
							codeTemplate += "<svg class=\"iconpress-icon " + svgSymbol[0].getAttribute("id") + "\" viewBox=\"" + svgSymbol[0].getAttribute("viewBox") + "\" style=\"" + style + "\" " + svgColorLink + "><title>" + finalTitle + "</title>";
							if (codeType == "svg") {
								codeTemplate += "<use href=\"#" + internal_id + "\" xlink:href=\"#" + internal_id + "\"></use>";
							} else if (codeType == "svg_inline") {
								codeTemplate += svgSymbol[0].innerHTML;
							}
							codeTemplate += "</svg>";

							// link end
							if (enableLink && link != "") {
								codeTemplate += "</a>";
							}
						}
					} else {
						console.error("Couldnt find the svg sprite!");
					}
				}

				// PHP CODE
				// intentionally spaced like this
				else if (codeType == "php") {
						codeTemplate = "<?php \n" + "if( function_exists('IconPress__getSvgIcon') ) { \n" + "  echo IconPress__getSvgIcon( \n" + "    array( \n" + "      'id' => '" + internal_id + "', \n" + "      'title' => __( '" + finalTitle + "', 'textdomain' ), \n" + "      'style' => '" + style + "', \n";

						if (enableLink && link != "") {
							codeTemplate += "      'link' => '" + link + "', \n";
							codeTemplate += "      'target' => '" + target + "', \n";
							codeTemplate += "      'color' => '" + color + "', \n";
							codeTemplate += "      'hover_color' => '" + hover_color + "', \n";
						}

						codeTemplate += "  ) ); \n} \n?>";
					}

			return codeTemplate;
		}

		/**
   * INSERTING METHODS
   */

		// Insert by copying to clipboard

	}, {
		key: "insertIntoEditor",


		// Inserting into WP Editor
		value: function insertIntoEditor() {
			// Pass the shortcode
			var settings = {
				shortcode: document.getElementById("codeTextArea").value
			};
			// Insert & Close
			this.insertValueAndClosePanel("wpeditor", settings);
		}

		// Insert into option

	}, {
		key: "insertIntoOption",
		value: function insertIntoOption(event, internal_id, integration_type) {
			event.preventDefault();

			var settings = {
				internal_id: internal_id
			};
			// Insert & Close
			this.insertValueAndClosePanel(integration_type, settings);
		}
	}, {
		key: "insertValueAndClosePanel",
		value: function insertValueAndClosePanel(context, newSettings) {
			var frame = window.frameElement;

			if (frame) {
				// close modal (with details)
				this.closeModal();

				var framePanel = frame.closest(".ip-insertPanel");
				var instanceId = framePanel.getAttribute("data-instance-id");
				var settings = {
					instance_id: instanceId
				};
				settings = Object.assign(settings, newSettings);
				// trigger event
				window.parent.dispatchEvent(new CustomEvent("iconpress:select:" + context, { detail: settings }));
				// close panel
				framePanel.classList.remove("is-visible");
			}
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			this.getIcons();
			this.getSystemIcons();

			document.addEventListener("keydown", this.escCloseModal, false);
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			document.removeEventListener("keydown", this.escCloseModal, false);
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			if (this.state.componentIsLoading) {
				return _react2.default.createElement(
					"div",
					{ className: "ip-tabPane" },
					_react2.default.createElement(
						"div",
						{ className: "ic-preloader" },
						_react2.default.createElement(_SvgIcon2.default, { icon: "spinner" })
					)
				);
			}

			var codeTypes = ["shortcode", "svg", "svg_inline", "php"];

			// Copy or Insert Button
			var copyInsertButton = _react2.default.createElement(
				"button",
				{ className: "ip-btn btn--black", onClick: function onClick(event) {
						return _this4.copyToClipboard("codeTextArea");
					} },
				iconPressConfig.translations.COPY
			);

			if (this.props.context === "wpeditor") {
				copyInsertButton = _react2.default.createElement(
					"button",
					{ className: "ip-btn btn--black", onClick: this.insertIntoEditor.bind(this) },
					iconPressConfig.translations.INSERT_SHORTCODE_INTO_EDITOR
				);
			}

			// Loading the editor
			var codeMirrorEditor = _react2.default.createElement(
				"div",
				{ className: "ip-cmEditor-loading" },
				_react2.default.createElement(_SvgIcon2.default, { icon: "spinner" })
			);

			if (this.state.activeModalCode === "editor" && this.state.itemCode) {
				codeMirrorEditor = _react2.default.createElement(_CodeMirror2.default, { code: this.state.itemCode, onChange: this.updateCode });
			}

			var systemIcons = _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					"h3",
					null,
					iconPressConfig.translations.SYSTEM_ICONS
				),
				_react2.default.createElement(
					"p",
					null,
					iconPressConfig.translations.SYSTEM_DESC,
					" ",
					_react2.default.createElement(
						"a",
						{ href: "https://customers.iconpress.io/kb/system-icons/", target: "_blank" },
						iconPressConfig.translations.READ_MORE
					)
				),
				_react2.default.createElement(
					"div",
					{ className: "ip-mcIcons" },
					this.state.system_collection.length !== 0 && this.state.system_collection.map(function (item, index) {
						return _react2.default.createElement(_MyCollection_Icon2.default, {
							key: item.internal_id,
							index: index,
							item: item,
							type_internal: "system",
							openModal: _this4.openModal,
							insertIntoOption: _this4.insertIntoOption,
							context: _this4.props.context,
							status: _this4.state.status
						});
					})
				)
			);

			var showSystemIcons = true;
			if (iconPressConfig.system_frontend == "0" && this.props.context != "management") {
				showSystemIcons = false;
			}

			return _react2.default.createElement(
				_react2.default.Fragment,
				null,
				_react2.default.createElement(
					"div",
					{ className: "ip-tabPane ip-mcIcon-wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "ip-tabPane-inner" },
						iconPressConfig.debug == 1 && _react2.default.createElement(
							"div",
							{ className: "ip-mcExtra" },
							_react2.default.createElement(
								"span",
								{
									className: "ip-btn ip-btn--lined ip-btn--red ip-mcExtra-removeAll",
									onClick: this.handleDeleteAll
								},
								"REMOVE ALL"
							)
						),
						_react2.default.createElement(
							"h2",
							{ className: "ip-mcIcons-title" },
							iconPressConfig.translations.YOUR_CUSTOM_COLLECTION
						),
						this.state.my_collection.length === 0 && _react2.default.createElement(
							"div",
							null,
							iconPressConfig.translations.EMPTY,
							" ",
							_react2.default.createElement(
								"a",
								{
									href: iconPressConfig.main_url,
									target: this.props.context == "management" ? "_self" : "_blank"
								},
								iconPressConfig.translations.ADD_ICONS
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-mcIcons" },
							this.state.my_collection.length !== 0 && this.state.my_collection.map(function (item, index) {
								return _react2.default.createElement(_MyCollection_Icon2.default, {
									key: item.internal_id,
									index: index,
									item: item,
									type_internal: "custom",
									handleDelete: _this4.handleDelete,
									openModal: _this4.openModal,
									insertIntoOption: _this4.insertIntoOption,
									status: _this4.state.status,
									context: _this4.props.context,
									handleDownload: _this4.handleDownload
								});
							})
						),
						showSystemIcons && systemIcons
					)
				),
				Object.keys(this.state.modalItem).length !== 0 && _react2.default.createElement(
					_Modal2.default,
					{ className: "ip-codeModal", closeModal: this.handleCloseModal.bind(this) },
					this.state.activeModalCode !== "editor" && this.state.activeModalCode !== "attribution" && _react2.default.createElement(
						"div",
						{ className: "ip-cmCustomize" },
						_react2.default.createElement(
							"h3",
							null,
							iconPressConfig.translations.CUSTOMIZE_CODE
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-6" },
								_react2.default.createElement(
									"div",
									{ className: "ip-label" },
									iconPressConfig.translations.TITLE_ATTRIBUTE
								),
								_react2.default.createElement("input", {
									type: "text",
									className: "ip-textField",
									value: this.state.modalItemOptions.title,
									onChange: function onChange(event) {
										_this4.changeVal(event, "title");
									}
								})
							),
							_react2.default.createElement(
								"div",
								{ className: "ip-col-3" },
								_react2.default.createElement(
									"div",
									{ className: "ip-label" },
									iconPressConfig.translations.COLOR
								),
								_react2.default.createElement(_ColorPickerComponent2.default, {
									changeColor: this.changeColor,
									name: "color",
									defaultColor: this.state.modalItemOptions.color
								})
							),
							_react2.default.createElement(
								"div",
								{ className: "ip-col-3" },
								_react2.default.createElement(
									"div",
									{ className: "ip-label" },
									iconPressConfig.translations.SIZE
								),
								_react2.default.createElement(
									"div",
									{ className: "ip-row ip-row--gutter5" },
									_react2.default.createElement(
										"div",
										{ className: "ip-col-6" },
										_react2.default.createElement("input", {
											type: "number",
											className: "ip-textField",
											value: this.state.modalItemOptions.size,
											onChange: function onChange(event) {
												_this4.changeVal(event, "size");
											}
										})
									),
									_react2.default.createElement(
										"div",
										{ className: "ip-col-6" },
										_react2.default.createElement(
											"select",
											{
												className: "ip-selectList",
												value: this.state.modalItemOptions.unit,
												onChange: function onChange(event) {
													_this4.changeVal(event, "unit");
												}
											},
											["px", "em", "rem"].map(function (key) {
												return _react2.default.createElement(
													"option",
													{ key: key, value: key },
													key
												);
											})
										)
									)
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-12" },
								_react2.default.createElement("input", {
									type: "checkbox",
									id: "enableLink",
									className: "ip-checkbox",
									checked: this.state.modalItemOptions.enableLink,
									onChange: this.toggleLink.bind(this)
								}),
								_react2.default.createElement(
									"label",
									{ htmlFor: "enableLink", className: "ip-label" },
									"ENABLE LINK"
								)
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-row " + (!this.state.modalItemOptions.enableLink ? "is-hidden" : "") },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-6" },
								_react2.default.createElement(
									"div",
									{ className: "ip-label" },
									"LINK"
								),
								_react2.default.createElement("input", {
									type: "text",
									className: "ip-textField",
									placeholder: "http://",
									onChange: function onChange(event) {
										_this4.changeVal(event, "link");
									}
								})
							),
							_react2.default.createElement(
								"div",
								{ className: "ip-col-3" },
								_react2.default.createElement(
									"div",
									{ className: "ip-label" },
									"TARGET"
								),
								_react2.default.createElement(
									"select",
									{
										className: "ip-selectList",
										onChange: function onChange(event) {
											_this4.changeVal(event, "target");
										}
									},
									_react2.default.createElement(
										"option",
										{ value: "_self" },
										"Same Window"
									),
									_react2.default.createElement(
										"option",
										{ value: "_blank" },
										"New Window"
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "ip-col-3" },
								_react2.default.createElement(
									"div",
									{ className: "ip-label" },
									"HOVER COLOR"
								),
								_react2.default.createElement(_ColorPickerComponent2.default, {
									changeColor: this.changeColor,
									name: "hover_color",
									defaultColor: this.state.modalItemOptions.hover_color ? this.state.modalItemOptions.hover_color : this.state.modalItemOptions.color
								})
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-12" },
								_react2.default.createElement(
									"div",
									{ className: "ip-cmCode" },
									this.props.context === "management" && codeTypes.map(function (ct) {
										return _react2.default.createElement(
											"span",
											{
												key: ct,
												className: ct == _this4.state.activeModalCode ? "is-active" : "",
												onClick: function onClick(event) {
													_this4.switchActiveCode(event, ct);
												}
											},
											ct.replace("_", " ")
										);
									}),
									_react2.default.createElement("textarea", {
										id: "codeTextArea",
										className: "ip-textField",
										readOnly: true,
										value: this.getCode()
									}),
									copyInsertButton
								)
							)
						),
						this.state.notice !== "" && _react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-12" },
								_react2.default.createElement(
									"p",
									{ className: "ip-note" },
									this.state.notice
								)
							)
						)
					),
					this.state.activeModalCode === "editor" && _react2.default.createElement(
						"div",
						{ className: "ip-cmEditor" },
						_react2.default.createElement(
							"h3",
							null,
							iconPressConfig.translations.SVG_CODE_EDITOR
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-12" },
								codeMirrorEditor
							)
						),
						_react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-12" },
								_react2.default.createElement(
									"button",
									{
										className: "ip-btn ip-btn--green",
										onClick: function onClick(event) {
											return _this4.saveIconCode(event, true);
										}
									},
									iconPressConfig.translations.SAVE
								),
								_react2.default.createElement(
									"button",
									{
										className: "ip-btn ip-btn--black",
										onClick: function onClick(event) {
											return _this4.saveIconCode(event);
										}
									},
									iconPressConfig.translations.SAVE_AS_NEW
								)
							)
						)
					),
					this.state.activeModalCode === "attribution" && _react2.default.createElement(
						"div",
						{ className: "ip-credits" },
						_react2.default.createElement(
							"h3",
							null,
							iconPressConfig.translations.ICON_INFORMATION
						),
						this.state.modalItem.author && this.state.modalItem.license ? _react2.default.createElement(
							"div",
							{ className: "ip-row" },
							_react2.default.createElement(
								"div",
								{ className: "ip-col-12" },
								_react2.default.createElement(
									"p",
									{ className: "ip-text-md u-mt-0 u-mb-25" },
									_react2.default.createElement(
										"strong",
										null,
										(0, _helpers.capitalize)(this.state.modalItem.title),
										" "
									),
									iconPressConfig.translations.ICON_MADE_BY,
									_react2.default.createElement(
										"a",
										{ href: (0, _helpers.referrize)(this.state.modalItem.author.url), target: "_blank" },
										this.state.modalItem.author.name
									),
									",",
									iconPressConfig.translations.LICENSED_AS,
									this.state.modalItem.license.url ? _react2.default.createElement(
										"a",
										{
											href: (0, _helpers.referrize)(this.state.modalItem.license.url),
											target: "_blank"
										},
										this.state.modalItem.license.name
									) : this.state.modalItem.license.name,
									"."
								),
								_react2.default.createElement(
									"h3",
									null,
									iconPressConfig.translations.COPY_ATTRIBUTION
								),
								_react2.default.createElement(
									"p",
									{ className: "ip-note" },
									iconPressConfig.translations.SHOW_SUPPORT
								),
								_react2.default.createElement("textarea", {
									id: "attrTextArea",
									className: "ip-textField",
									readOnly: true,
									value: (0, _helpers.capitalize)(this.state.modalItem.title) + " " + iconPressConfig.translations.ICON_MADE_BY + " <a href=\"" + this.state.modalItem.author.url + "\" target=\"_blank\">" + this.state.modalItem.author.name + "</a>."
								}),
								_react2.default.createElement(
									"button",
									{
										className: "ip-btn ip-btn--green",
										onClick: function onClick(event) {
											return _this4.copyToClipboard("attrTextArea");
										}
									},
									iconPressConfig.translations.COPY
								)
							)
						) : _react2.default.createElement(
							"div",
							null,
							"Missing informations."
						)
					),
					_react2.default.createElement(_PreviewBox2.default, {
						color: this.state.modalItemOptions.color,
						size: this.state.modalItemOptions.size,
						unit: this.state.modalItemOptions.unit,
						code: this.state.itemCode,
						internal_id: this.state.modalItem.internal_id,
						changeVal: this.changeVal,
						codeType: this.state.activeModalCode
					})
				)
			);
		}
	}]);

	return MyCollection;
}(_react2.default.Component);

MyCollection.propTypes = {
	my_collection: _propTypes2.default.array,
	system_collection: _propTypes2.default.array
};

exports.default = MyCollection;


//////////////////
// WEBPACK FOOTER
// ./src/components/MyCollection.js
// module id = 261
// module chunks = 0 1